import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

export default function NotFound() {
  const location = useLocation();
  
  useEffect(() => {
    document.title = "Page Not Found - SunRoute Group LLC";
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute("content", "The page you are looking for could not be found. SunRoute Group LLC offers professional freight transportation and logistics services throughout the United States.");
    }
    
    const metaRobots = document.querySelector('meta[name="robots"]');
    if (!metaRobots) {
      const newMetaRobots = document.createElement('meta');
      newMetaRobots.name = "robots";
      newMetaRobots.content = "noindex, nofollow";
      document.head.appendChild(newMetaRobots);
    }
    
    const canonicalLink = document.querySelector('link[rel="canonical"]');
    if (canonicalLink) {
      canonicalLink.setAttribute("href", `${siteUrl}/404`);
    }
    
    return () => {
      const robotsMeta = document.querySelector('meta[name="robots"]');
      if (robotsMeta) {
        robotsMeta.remove();
      }
    };
  }, []);
  
  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-gray-50 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <h2 className="text-xl md:text-2xl font-semibold mt-6">This page has not been generated</h2>
        <p className="mt-2 text-base text-gray-400 font-mono">{location.pathname}</p>
        <p className="mt-4 text-lg md:text-xl text-gray-500">Tell me more about this page, so I can generate it</p>
      </div>
    </div>
  );
}